import React, { FC } from 'react';
import { Card, Container } from '@mui/material';
import { useUiContext } from 'src/UIProvider';
import { DashboardHeader } from 'src/UIKit/DashboardHeader';
import { observer } from 'mobx-react-lite';
import {TextEditor} from "../../../../UIKit/TextEditor";
import {PLAIN_TEXT_LENGTH} from "../../../../utils/Utils";
import {CheckboxAutocompleteSingle} from "../components/autocompleteTree";
import { CategoryImageDropZone } from '../components/categoryImageDropZone';
import { TextInput } from 'src/UIKit/TextInput';
import { useCategoryCreating } from '../../presenters/useCategoryCreating';

export const CategoryCreatingView: FC = observer(() => {
    const { t } = useUiContext();
    const { category, categories, parent, errors, onChange, onSelectCategory, onChangeCategory, onCreateCategory } = useCategoryCreating();

    return (
        <Container maxWidth="xl">
            <DashboardHeader title={t('createCategory')} buttonTitle={t('save')} onPress={onCreateCategory} />
            <CategoryImageDropZone />
            <Card sx={{ p: 2, mb: 2 }}>
                <TextInput label={t('name')} name='name' onChange={onChange} value={category?.name} error={errors} required />
                <TextEditor
                    label={t('common.description')}
                    name='description'
                    onChange={onChange}
                    value={category?.description}
                    error={errors}
                    maxLength={PLAIN_TEXT_LENGTH}
                    required
                />
                {/*<TextInput label={t('slug')} name='slug' onChange={onChange} value={category?.slug} error={errors} required />*/}
                <CheckboxAutocompleteSingle title={t('parentCategory')} optionList={categories} onSelect={onSelectCategory} value={parent?.id} onChange={onChangeCategory} error={errors} name='category_id' isDisabled={true}/>
            </Card>
        </Container>
    );
})
